import { FC } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import rodeoButtonImage from 'assets/rodeo-button.png'
import rodeoButtonActiveImage from 'assets/rodeo-button-active.svg'
import { ImageButton } from './ImageButton'
import {
  pulseAnimation,
  sansSerifFontFamily,
  serifFontFamily,
} from '../utils/styles'

const useStyles = createUseStyles({
  button: {
    animation: '$pulseAnimation 3s infinite',
  },
  '@keyframes pulseAnimation': pulseAnimation,
  number: {
    fontFamily: sansSerifFontFamily,
    fontSize: 12,
    fontWeight: 700,
    color: 'white',
    margin: 0,
    marginTop: -1,
    marginRight: -1,
    position: 'relative',
  },
  title: {
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: serifFontFamily,
    fontSize: 14,
    fontWeight: 700,
    color: 'white',
    textTransform: 'lowercase',
  },
})

interface Props {
  number: number
  title?: string
  onClick: () => void
  active?: boolean
  className?: string
}

export const RodeoButton: FC<Props> = flowMax(
  addDisplayName('RodeoButton'),
  addProps(({ active }) => ({
    image: active ? rodeoButtonActiveImage : rodeoButtonImage,
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ number, title, active, image, onClick, classes, className }) => (
    <ImageButton
      width={64}
      height={64}
      image={image}
      onClick={onClick}
      className={cx(classes.button, className)}
    >
      {!active && <p className={classes.number}>{number.toLocaleString()}</p>}
      {title && <div className={classes.title}>{title}</div>}
    </ImageButton>
  )
)
